<template>
  <div class="w100 cpfa">
    <div class="flexslider">
      <ul class="slides">
        <div
          class="lunBotu"
          :style="{ background: 'url(' + require('@/assets/' + bannerImgs['background']) + ')' }"
        >
          <div class="container">
            <div class="ban2 float">
              <slot name="context"></slot>
            </div>
            <img class="banner" :src="require('@/assets/' + bannerImgs['right'])" />
          </div>
        </div>
      </ul>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Banner',
  props: {
    bannerImgs: {
      type: Object,
      required: true
    }
  },
  data () {
    return {
    }
  },
  methods: {
  }
}
</script>

<style scoped>
.flexslider {
  position: relative;
  height: 584px;
  overflow: hidden;
  z-index: 1;
  clear: both;
  margin-top: -65px;
}
.cpfa .container {
  padding-top: 127px;
  padding-left: -14px;
}
.container {
    width: 997px;
    padding-top: 147px;
    min-width: 997px;
}
.lunBotu {
  margin-top: 4px;
  background-repeat: initial;
  z-index: 1;
  background-size: 100% 100%;
  height: 587px;
}
.banner {
  width: 100%;
  height: 100%;
}
</style>



// WEBPACK FOOTER //
// src/components/pages/coreTechnology/Banner.vue